import React, {useEffect, useState} from "react";
import DataTable from "../../../components/data-table";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import Button from "../../../components/button";
import Modal from "../../../components/modal";
import LoadingSpinner from '../../../components/loading-spinner';

import {
    clear_vehicle_maintenance,
    createVehicleMaintenance,
    CREATE_VEHICLE_MAINTENANCE,
    getAllVehicleMaintenance,
} from "../../../redux/vehicle_maintenance";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Input from "../../../components/input";
import TextArea from "../../../components/text-area";

const VehicleMaintenance = (props) => {
    let history = useHistory();
    let dispatch = useDispatch();

    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const _get_all_vehicle_maintenance = useSelector((state) => state.vehicle_maintenance_module._get_all_vehicle_maintenance);
    const _create_vehicle_maintenance = useSelector((state) => state.vehicle_maintenance_module._create_vehicle_maintenance);
    const [data, setData] = useState([]);

    useEffect(() => {
        dispatch(getAllVehicleMaintenance(token));
    }, [token, dispatch]);

    useEffect(() => {
        if (_get_all_vehicle_maintenance && _get_all_vehicle_maintenance.data && _get_all_vehicle_maintenance.data.datos) {
            setData(_get_all_vehicle_maintenance.data.datos);
        }
    }, [_get_all_vehicle_maintenance]);

    const [permisos, setPermisos] = useState([]);
    const [actions, setActions] = useState([]);
    const [modal, setModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [id, setId] = useState(0);

    const [form, setForm] = useState({
        descripcion: "",
        kilometraje_desde: "",
        kilometraje_hasta: "",
        activo: true,
    });

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
    }, [props]);

    useEffect(() => {
        let act = []
        if (permisos) {
            if (permisos.filter(x => x.codigo === 'view_vehiclemaintenance').length > 0) {
                act.push({
                    name: "edit",
                    label: "Edit",
                    icon: "bx bx-edit",
                    color: "calendar",
                    onClick: (item) => {
                        setModal(true);
                        setId(item.id);
                        history.push(`/mantenimiento/vehiculo/editar/${item.id}`);
                    },
                })
            }
        }
        setActions(act);
        // eslint-disable-next-line
    }, [permisos, history]);

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    useEffect(() => {
        if (_create_vehicle_maintenance.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_vehicle_maintenance(CREATE_VEHICLE_MAINTENANCE));
            dispatch(getAllVehicleMaintenance(token));
            let id_vehicle_maintenance = _create_vehicle_maintenance.data.id;
            history.push(`/mantenimiento/vehiculo/editar/${id_vehicle_maintenance}`);
            setIsLoading(false);
            setModal(false);
        } else if (_create_vehicle_maintenance.status !== 0) {
            dispatch(clear_vehicle_maintenance(CREATE_VEHICLE_MAINTENANCE));
            toast.error(_create_vehicle_maintenance.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_create_vehicle_maintenance, dispatch, history, token, id]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (form.descripcion === "") {
            toast.error("Debe una descripción", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.kilometraje_desde === "") {
            toast.error("Debe ingresar el kilometraje inicial", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.kilometraje_hasta === "") {
            toast.error("Debe ingresar el kilometraje final", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        dispatch(createVehicleMaintenance(token, form));
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Lista"
                            items={[{label: "Mantenimientos del vehículo", link: "/mantenimientos-vehiculos"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div><ToastContainer/></div>
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                {
                                    permisos.filter(x => x.codigo === 'add_vehiclemaintenance').length > 0 ?
                                        <Button type="button" text="Crear" theme="btn btn-success" onClick={() => {
                                            setModal(true);
                                            setForm({...form, descripcion: '', kilometraje_desde: '', kilometraje_hasta: ''});
                                            setId(0);
                                        }}/> : null
                                }
                                <div className="table-responsive">
                                    <DataTable
                                        dataTable={data}
                                        columns={[
                                            {
                                                name: "fecha_creacion",
                                                label: "Fecha de creación",
                                                type: "text",
                                            },
                                            {
                                                name: "descripcion",
                                                label: "Descripción",
                                                type: "text",
                                            },
                                            {
                                                name: "kilometraje_desde",
                                                label: "Kilometraje inicial",
                                                type: "text",
                                            },
                                            {
                                                name: "kilometraje_hasta",
                                                label: "Kilometraje final",
                                                type: "text",
                                            },
                                            {
                                                name: "activo",
                                                label: "Activo",
                                                type: "boolean",
                                            },
                                        ]}
                                        actions={actions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                {isLoading && <LoadingSpinner/>}
                <div className="modal-content">
                    <div className="modal-header">
                        <h5>Crear mantenimiento del vehículo</h5>
                    </div>
                    <div className="modal-body p-2">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <TextArea
                                    label="Descripción"
                                    name="descripcion"
                                    onChange={handleChange}
                                    value={form.descripcion}
                                    rows={5}
                                />
                            </div>
                            <div className="form-group">
                                <Input
                                    name="kilometraje_desde"
                                    label="Kilometraje inicial"
                                    value={form.kilometraje_desde}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <Input
                                    name="kilometraje_hasta"
                                    label="Kilometraje final"
                                    value={form.kilometraje_hasta}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="text-center">
                                <button type="button" className="btn btn-outline-dark" onClick={() => {
                                    setModal(false);
                                }}> Cancelar
                                </button>
                                <Button type="submit" text="Guardar" theme="btn btn-success" classes="m-1"
                                        disabled={isLoading}/>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default VehicleMaintenance;
